import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ResponsiveService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class BreakpointGuard implements CanActivate {
  private responsive = inject(ResponsiveService);

  canActivate(): boolean {
    return this.responsive.$isMobile();
  }
}
